import styled from 'styled-components';

export const Inner = styled.div`
  flex: 1 1 auto;
`;

export const Dependence = styled.div`
  position: relative;
  display: flex;
  transition: all 0.4s;

  // Arrow line styles
  &:before {
    flex: 0 0 auto;
    display: inline-block;
    width: 32px;
    height: 51px;
    margin-right: 16px;
    border-width: 0 0 2px 2px;
    border-style: solid;
    border-color: #999;
    border-radius: 0 0 0 4px;
    content: '';
  }
  // Arrow chevron styles
  &:after {
    position: absolute;
    left: 32px;
    top: 51px;
    display: inline-block;
    width: 10px;
    height: 10px;
    border-width: 0 2px 2px 0;
    border-style: solid;
    border-color: #999;
    transform: translate(-100%, -60%) rotate(-45deg);
    content: '';
  }
`;
